import { Injectable } from '@angular/core';

import { HttpService } from '../services/http.service';
import { LocalStorageService } from '../services/local-storage.service';

import { SignerService } from '../services/signer/signer.service';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private httpService: HttpService,
    private localStorageService: LocalStorageService,
    private signerService: SignerService,
  ) {}

  isAuthenticated() {
    return !!this.signerService.get();
  }

  getSignerInfo(params) {
    return this.httpService.postData('api/v1/account/signers', params, true);
  }
}
